var $35cd24659c58727a$exports = {};
$35cd24659c58727a$exports = {
    "collectionLabel": `\u{645}\u{642}\u{62A}\u{631}\u{62D}\u{627}\u{62A}`
};


export {$35cd24659c58727a$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
